import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useLocalSessionId, useVideoTrack, useAudioTrack, useAudioLevel } from '@daily-co/daily-react';
import Mic from '../Mic/Mic';
import { throttle } from 'lodash';
import UserMediaService from '../../../services/UserMediaService';

const LocalMic: React.FC<{ isEnabled: boolean, audioTrack: MediaStreamTrack | undefined, height?: number }> = ({ isEnabled, audioTrack, height = 18 }) => {
  const [volume, setVolume] = useState(0);

  const sourceNode = useRef<MediaStreamAudioSourceNode | undefined>();
  const analyserNode = useRef<AnalyserNode | undefined>();
  const frequencyData = useRef(new Uint8Array(1));
  const updateInterval = useRef<number | undefined>();;

  const setTrack = (track: MediaStreamTrack) => {
    stop();
    if (!track) return;

    try {
      const audioContext = UserMediaService.getAudioContext();
      sourceNode.current = audioContext.createMediaStreamSource(new MediaStream([track]));
      analyserNode.current = audioContext.createAnalyser();
      sourceNode.current.connect(analyserNode.current);
      updateInterval.current = window.setInterval(updateVuMeter, 90);
    } catch (e) {
      console.error(e);
    }
  }

  const updateVuMeter = () => {
    if (!analyserNode.current) return;
    analyserNode.current.getByteFrequencyData(frequencyData.current);
    handleVolumeChange(frequencyData.current[0]);
  };

  const stop = () => {
    if (sourceNode.current) sourceNode.current.disconnect();
    if (analyserNode.current) analyserNode.current.disconnect();
    if (updateInterval.current) clearInterval(updateInterval.current);
  }
  
  const handleVolumeChange = useCallback((value: number) => {
    const valueNormalized = value / 180;
    setVolume(valueNormalized);
  }, []);

  useEffect(() => {
    const isAudioTrackEnabled = audioTrack?.readyState === 'live' && isEnabled;
    if (isAudioTrackEnabled && audioTrack) {
      setTrack(audioTrack);
    }

    if (!isEnabled) stop();

    return () => {
      stop();
    }
  }, [audioTrack, audioTrack?.readyState, isEnabled])

  return (
    <Mic isEnabled={isEnabled} volume={volume} height={height} />
  );
};

export default LocalMic;
